import { useOnlineStatus } from '@/hooks/useOnlineStatus'
import { WifiOff } from 'lucide-react'
import { ReactNode } from 'react'

type OnlineStatusProviderProps = {
  children: ReactNode
}

const OnlineStatusProvider = ({ children }: OnlineStatusProviderProps) => {
  const isOnline = useOnlineStatus()

  if (isOnline) {
    return children
  }

  return (
    <div className="h-dvh flex flex-col items-center justify-center gap-4">
      <WifiOff className="size-20 text-muted-foreground" />
      <div className="max-w-lg text-center">
        <h4 className="mb-2">Oops! You're Offline</h4>
        <p>
          Looks like we lost the connection. Double-check your network and try again. Once we're back online, you can pick up right where
          you left off.
        </p>
      </div>
    </div>
  )
}

export { OnlineStatusProvider }
